import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigProvider } from '../config/config';

import { Account } from '../../models/models';

/*
  Generated class for the AccountProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AccountProvider {
	constructor(
		public http: HttpClient
	) {
	}

	/*
	Recupera i contatti del condominio con ID passato
	*/
	public sendPin(pin: number): Promise<void> {
		let request = this.http.get(ConfigProvider.HOST + "/account/pin/" + pin + "/send");
		return new Promise<void>((resolve, reject) => {
			request.subscribe(success => {
				console.log('PIN inviato per email')
				resolve()
			}, error => {
				console.error('Errore inviando il PIN per email', error)
				reject(error)
			});
		})
	}

	/**
	Crea un nuovo account sul server
	*/
	public store(account: Account): Promise<Account> {
		let self = this;
		return new Promise<Account>((resolve, reject) => {
			if (!account) {
				reject('Utente nullo: Impossibile persisterlo');
				return;
			}
			if (!account.user_id) {
				console.error('Account senza utente specificato', account);
				reject('Utente proprietario non specificato');
				return;
			}
			if (!account.identifier) {
				console.error('Account senza identificatore univoco specificato', account);
				reject('Itentificativo non specificato');
				return;
			}
			if (!account.type) {
				console.error('Tipo di account non specificato', account);
				reject('Tipo non specificato');
				return;
			}

			let params = new HttpParams();
			for (let property in account) {
				if (account.hasOwnProperty(property) && account[property] !== null) {//api_token forza il login e va gestito da server
					params = params.append(property, account[property]);
				}
			}

			let request = self.http.post<Account>(ConfigProvider.HOST + '/account/store', params);
			request.subscribe(
				account => {
					if (!account || !account.id) {//Chiamata ok ma non ha trovato l'utente
						console.warn("Creazione dell'account fallita", account);
						reject("Creazione dell'account fallita");
						return;
					}
					resolve(account);
				}, error => {
					console.error("Errore creando l'account", error);
					reject(error);
				}
			);
		});
	}
}



// WEBPACK FOOTER //
// ./src/providers/account/account.ts